<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Header -->
    <div
      class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm transition-all duration-300">
      <div class="flex items-center gap-3 px-5 py-4">
        <button
          class="h-10 w-10 grid place-items-center rounded-2xl hover:bg-slate-50 active:scale-95 transition-all text-slate-700"
          (click)="editMode() ? cancelEdit() : toBack()">
          <span class="material-symbols-outlined text-slate-700">arrow_back</span>
        </button>
        <div class="flex-1">
          <h1 class="text-[17px] font-black text-slate-800 tracking-tight">
            {{ (editMode() ? 'แก้ไขข้อมูลส่วนตัว' : 'ข้อมูลส่วนตัวของฉัน') | translate : 'profile' }}
          </h1>
        </div>
        <app-language-switcher />
        @if (!loading() && !editMode()) {
        <button
          class="flex items-center gap-2 text-[13px] font-bold text-blue-700 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 rounded-xl px-4 py-2.5 transition-all shadow-sm active:scale-95 border border-blue-100"
          (click)="startEdit()">
          <span class="material-symbols-outlined text-[16px]">draw</span>
          <span class="hidden sm:inline">{{ 'แก้ไข' | translate : 'profile' }}</span>
        </button>
        }
      </div>
    </div>

    <!-- Scrollable Area -->
    <div class="flex-1 overflow-y-auto w-full">
      @if (loading()) {
      <!-- Skeleton -->
      <div class="px-5 pt-8 pb-10 space-y-4 animate-pulse">
        <div
          class="bg-white rounded-3xl p-6 flex flex-col items-center gap-4 relative overflow-hidden border border-slate-100 shadow-sm">
          <div class="absolute top-0 inset-x-0 h-16 bg-gradient-to-r from-slate-200 to-slate-100 opacity-50"></div>
          <div class="w-24 h-24 rounded-full bg-slate-200 relative z-10 border-4 border-white shadow-sm"></div>
          <div class="flex flex-col items-center gap-2 z-10 w-full mt-2">
            <div class="h-5 bg-slate-200 rounded-lg w-1/2"></div>
            <div class="h-3 bg-slate-100 rounded-lg w-2/3"></div>
          </div>
        </div>
        <div class="bg-white rounded-3xl border border-slate-100 shadow-sm divide-y divide-slate-100">
          @for (i of [1,2,3]; track i) {
          <div class="p-5 flex gap-4 items-center">
            <div class="w-10 h-10 rounded-xl bg-slate-100 shrink-0"></div>
            <div class="flex-1 space-y-2">
              <div class="h-3 bg-slate-100 rounded-md w-1/3"></div>
              <div class="h-4 bg-slate-200 rounded-md w-3/4"></div>
            </div>
          </div>
          }
        </div>
      </div>
      } @else if (editMode()) {

      <!-- ─── EDIT MODE ─── -->
      <div class="px-5 pt-6 pb-32 space-y-5">
        <!-- Note -->
        <div
          class="flex items-start gap-2 bg-blue-50 p-3 rounded-2xl border border-blue-100 text-[11px] font-medium text-blue-700">
          <span class="material-symbols-outlined text-blue-500 text-[16px] shrink-0 mt-0.5">info</span>
          <span class="leading-relaxed">{{ 'ตรวจสอบความถูกต้องของข้อมูลก่อนกดยืนยันบันทึกข้อมูลเพื่อใช้ในการอ้างอิง' | translate : 'profile' }}</span>
        </div>

        <div
          class="bg-white rounded-3xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] overflow-hidden divide-y divide-slate-50">

          <!-- ชื่อ -->
          <div class="p-5">
            <label class="flex items-center gap-2 text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-2.5">
              <span class="material-symbols-outlined text-blue-500 text-[16px]">badge</span>
              {{ 'ชื่อ' | translate : 'profile' }}<span class="text-red-400 ml-0.5">*</span>
            </label>
            <input type="text" [(ngModel)]="editForm.firstname" [placeholder]="'กรอกชื่อ' | translate : 'profile'"
              class="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-[15px] font-semibold text-slate-800 placeholder:text-slate-300 placeholder:font-normal focus:bg-white focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10 outline-none transition-all" />
          </div>

          <!-- นามสกุล -->
          <div class="p-5">
            <label class="flex items-center gap-2 text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-2.5">
              <span class="material-symbols-outlined text-blue-500 text-[16px]">badge</span>
              {{ 'นามสกุล' | translate : 'profile' }}<span class="text-red-400 ml-0.5">*</span>
            </label>
            <input type="text" [(ngModel)]="editForm.lastname" [placeholder]="'กรอกนามสกุล' | translate : 'profile'"
              class="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-[15px] font-semibold text-slate-800 placeholder:text-slate-300 placeholder:font-normal focus:bg-white focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10 outline-none transition-all" />
          </div>

          <!-- หมายเลขโทรศัพท์ -->
          <div class="p-5">
            <label class="flex items-center gap-2 text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-2.5">
              <span class="material-symbols-outlined text-amber-500 text-[16px]">phone</span>
              {{ 'หมายเลขโทรศัพท์ระบุติดต่อ' | translate : 'profile' }}
            </label>
            <div class="flex gap-2.5">
              <input type="text" [(ngModel)]="editForm.phoneCode" placeholder="+66"
                class="w-[70px] shrink-0 rounded-2xl border border-slate-200 bg-slate-50 px-3 py-3.5 text-[15px] font-semibold text-slate-800 placeholder:text-slate-300 focus:bg-white focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10 outline-none transition-all text-center" />
              <input type="tel" [(ngModel)]="editForm.phoneNumber" [placeholder]="'กรอกเบอร์โทรศัพท์' | translate : 'profile'"
                class="flex-1 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-[15px] font-semibold text-slate-800 placeholder:text-slate-300 placeholder:font-normal focus:bg-white focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10 outline-none transition-all" />
            </div>
          </div>

        </div>

        <!-- Bottom Actions inside Edit Mode (sticky at bottom of container or scroll) -->
        <div
          class="absolute bottom-0 inset-x-0 p-5 bg-white/80 backdrop-blur-xl border-t border-slate-100 shadow-[0_-10px_30px_rgba(0,0,0,0.05)] z-20 space-y-3">
          <!-- Error -->
          @if (saveError()) {
          <div
            class="rounded-2xl bg-red-50 border border-red-200 px-4 py-3 flex items-start gap-2.5 text-xs text-red-600 shadow-sm">
            <span class="material-symbols-outlined text-[16px] text-red-500 shrink-0 mt-0.5">error</span>
            <span class="leading-relaxed font-medium">{{ saveError() | translate : 'api' }}</span>
          </div>
          }
          <button
            class="w-full rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 py-4 text-[15px] font-bold text-white hover:from-blue-700 hover:to-indigo-700 active:scale-[0.98] transition-all shadow-lg shadow-blue-500/30 disabled:opacity-60 disabled:scale-100 flex items-center justify-center gap-2"
            [disabled]="saving()" (click)="saveProfile()">
            @if (saving()) {
            <span class="material-symbols-outlined text-[20px] animate-spin">progress_activity</span>
            {{ 'กำลังบันทึกข้อมูล...' | translate : 'profile' }}
            } @else {
            <span class="material-symbols-outlined text-[20px]">save</span>
            {{ 'บันทึกการเปลี่ยนแปลง' | translate : 'profile' }}
            }
          </button>
          <button
            class="w-full rounded-2xl border border-slate-200 bg-white py-3.5 text-[14px] font-bold text-slate-600 hover:bg-slate-50 hover:text-slate-900 active:scale-[0.98] transition-all"
            (click)="cancelEdit()">
            {{ 'ยกเลิก' | translate : 'profile' }}
          </button>
        </div>
      </div>

      } @else {

      <!-- ─── VIEW MODE ─── -->
      <div class="px-5 pt-8 pb-10 space-y-6">

        <!-- Profile Hero Card -->
        <div
          class="bg-white rounded-[2rem] shadow-[0_8px_30px_rgba(0,0,0,0.06)] overflow-hidden border border-slate-100">
          <div class="h-28 bg-gradient-to-br from-indigo-500 via-blue-500 to-cyan-500 relative overflow-hidden">
            <div
              class="absolute top-0 right-0 w-48 h-48 bg-white/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/3">
            </div>
            <div
              class="absolute bottom-0 left-0 w-32 h-32 bg-black/10 rounded-full blur-xl translate-y-1/2 -translate-x-1/3">
            </div>
          </div>
          <div class="px-6 pb-6 flex flex-col items-center -mt-14 relative z-10">
            <div class="relative mb-4 group cursor-pointer">
              <div class="w-28 h-28 rounded-[2rem] bg-white p-1.5 shadow-xl shadow-blue-500/10">
                <div
                  class="w-full h-full rounded-[1.5rem] overflow-hidden bg-slate-50 flex items-center justify-center">
                  @if (getAvatar()) {
                  <img [src]="getAvatar()" alt="avatar"
                    class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  } @else {
                  <div
                    class="w-full h-full bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center group-hover:scale-105 transition-transform duration-500">
                    <span class="material-symbols-outlined text-blue-300"
                      style="font-size:3.5rem">sentiment_satisfied</span>
                  </div>
                  }
                </div>
              </div>
              <div
                class="absolute -bottom-2 -right-2 w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center border-4 border-white shadow-sm hover:bg-blue-700 hover:scale-110 active:scale-95 transition-all">
                <span class="material-symbols-outlined text-white" style="font-size:1.1rem">add_a_photo</span>
              </div>
            </div>
            <div class="text-xl font-black text-slate-800 tracking-tight text-center">
              {{getName() || ('ยังไม่ได้ระบุชื่อ' | translate : 'profile')}}
            </div>
            <div class="flex items-center gap-1.5 mt-1">
              <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
              <div class="text-[13px] font-medium text-slate-500">
                {{getEmail() || ('ยังไม่ได้ระบุอีเมล' | translate : 'profile')}}
              </div>
            </div>
          </div>
        </div>

        <!-- Info Box -->
        <div class="bg-blue-50/50 rounded-2xl p-4 border border-blue-100/50 flex items-start gap-3">
          <span class="material-symbols-outlined text-blue-500 shrink-0 text-[20px]">security</span>
          <p class="text-[11px] text-blue-800/80 leading-relaxed font-medium">
            {{ 'ข้อมูลส่วนตัวของคุณถูกเก็บรักษาอย่างปลอดภัย ควบคุมการจัดการได้อย่างอิสระผ่านระบบของเรา' | translate : 'profile' }}
          </p>
        </div>

        <!-- Info rows -->
        <div
          class="bg-white rounded-[1.5rem] border border-slate-100 shadow-sm overflow-hidden divide-y divide-slate-50">

          <!-- ชื่อ - นามสกุล -->
          <div class="p-5 flex items-start gap-4 hover:bg-slate-50/50 transition-colors">
            <div
              class="w-10 h-10 rounded-[1rem] bg-blue-50 flex items-center justify-center shrink-0 border border-blue-100/50">
              <span class="material-symbols-outlined text-blue-500" style="font-size:1.2rem">person</span>
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 mt-0.5">{{ 'ชื่อ - นามสกุล' | translate : 'profile' }}
              </div>
              @if (getName()) {
              <div class="text-[15px] font-bold text-slate-800 truncate">{{getName()}}</div>
              } @else {
              <div class="text-[13px] text-red-400 font-bold flex items-center gap-1">
                <span class="material-symbols-outlined text-[16px]">error</span>
                {{ 'กรุณาระบุชื่อ' | translate : 'profile' }}
              </div>
              }
            </div>
          </div>

          <!-- อีเมล -->
          <div class="p-5 flex items-start gap-4 hover:bg-slate-50/50 transition-colors">
            <div
              class="w-10 h-10 rounded-[1rem] bg-emerald-50 flex items-center justify-center shrink-0 border border-emerald-100/50">
              <span class="material-symbols-outlined text-emerald-500" style="font-size:1.2rem">mail</span>
            </div>
            <div class="flex-1 min-w-0">
              <div
                class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 mt-0.5 flex justify-between items-center">
                <span>{{ 'อีเมลติดต่อ' | translate : 'profile' }}</span>
                @if (isEmailVerified()) {
                <span
                  class="flex items-center gap-1 rounded-full bg-emerald-100 text-emerald-700 text-[9px] px-2 py-0.5">
                  <span class="material-symbols-outlined text-[10px] font-bold">check</span> verified
                </span>
                }
              </div>
              @if (getEmail()) {
              <div class="text-[14px] font-bold text-slate-800 break-all leading-snug">{{getEmail()}}</div>
              } @else {
              <div class="text-[13px] text-slate-400 font-medium">{{ 'ไม่มีข้อมูลอีเมล' | translate : 'profile' }}</div>
              }
            </div>
          </div>

          <!-- หมายเลขโทรศัพท์ -->
          <div class="p-5 flex items-start gap-4 hover:bg-slate-50/50 transition-colors">
            <div
              class="w-10 h-10 rounded-[1rem] bg-amber-50 flex items-center justify-center shrink-0 border border-amber-100/50">
              <span class="material-symbols-outlined text-amber-500" style="font-size:1.2rem">call</span>
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 mt-0.5">{{ 'เบอร์โทรศัพท์' | translate : 'profile' }}
              </div>
              @if (getPhone()) {
              <div class="text-[15px] font-bold text-slate-800 font-mono tracking-tight">{{getPhone()}}</div>
              } @else {
              <div class="text-[13px] text-slate-400 font-medium italic">{{ "คลิก 'แก้ไข' เพื่อระบุเบอร์" | translate : 'profile' }}</div>
              }
            </div>
          </div>

        </div>

        <!-- Logout -->
        <button
          class="w-full flex items-center justify-center gap-2.5 rounded-2xl border border-red-200 bg-red-50 hover:bg-red-100 active:scale-[0.98] transition-all px-4 py-3.5 text-[14px] font-bold text-red-600"
          (click)="logout()">
          <span class="material-symbols-outlined text-[18px]">logout</span>
          {{ 'ออกจากระบบ' | translate : 'profile' }}
        </button>

      </div>
      }
    </div>
  </div>
</div>